import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Button, Form } from 'semantic-ui-react';
import {
  composeValidators,
  combineValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
} from 'revalidate';
import PropTypes from 'prop-types';
import TextInput from '../../../app/common/Form/TextInput';
import { updateProfilePassword } from '../userActions';

const formName = 'changePasswordForm';
const passwordMinLength = 6;
const passwordMaxLength = 17;
// const validMsg =
//   'Password should be alphanumeric and should have atleast one special characters (!@#$%^&*)';

const mapState = state => ({
  async: state.async,
  auth: state.auth
});

const actions = {
  updateProfilePassword
};

const validate = combineValidators({
  // password
  password: composeValidators(
    isRequired({ message: 'Old password is required' }),
    hasLengthGreaterThan(passwordMinLength - 1)({
      message: `Minimum length ${passwordMinLength} is allowed!`
    }),
    hasLengthLessThan(passwordMaxLength)({
      message: `Maximum length ${passwordMaxLength} is allowed!`
    }),
    // matchesPattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/)({
    //   message: validMsg
    // })
  )(),

  // newPassword
  newPassword: composeValidators(
    isRequired({ message: 'New password is required' }),
    hasLengthGreaterThan(passwordMinLength - 1)({
      message: `Minimum length ${passwordMinLength} is allowed!`
    }),
    hasLengthLessThan(passwordMaxLength)({
      message: `Maximum length ${passwordMaxLength} is allowed!`
    }),
    // matchesPattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/)({
    //   message: validMsg
    // })
  )(),
});

class ChangePasswordForm extends Component {
  static propTypes = {
    async: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    updateProfilePassword: PropTypes.func.isRequired
  };

  state = {
    password: '',
    newPassword: '',
    confirmPassword: ''
  };

  submit = values => {
    const { auth, updateProfilePassword } = this.props;

    // update password
    updateProfilePassword(
      values['password'],
      values['newPassword'],
      auth.csrfRequestIdentifier,
      () => {
        this.props.destroy();
      }
    );
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { async, handleSubmit, invalid, submitting, pristine } = this.props;

    return (
      <React.Fragment>
        <Form
          onSubmit={handleSubmit(this.submit)}
          loading={async.key === 'updatename' && async.loading}
        >
          <Field
            name="password"
            placeholder="Old Password"
            type="password"
            component={TextInput}
            value={this.state.password}
            onChange={this.handleChange}
          />

          <Field
            name="newPassword"
            placeholder="New Password"
            type="password"
            component={TextInput}
            value={this.state.newPassword}
            onChange={this.handleChange}
          />

          <Button
            className="fcbtn fcprimary"
            disabled={invalid || submitting || pristine}
          >
            Save Changes
          </Button>
        </Form>
      </React.Fragment>
    );
  }
}

export default connect(
  mapState,
  actions
)(
  reduxForm({ 
    form: formName, 
    enableReinitialize: true, 
    validate 
  })(
    ChangePasswordForm
  )
);
